/**
 * Creates a deep clone of an object
 * @see {@link https://javascript.plainenglish.io/deep-clone-an-object-and-preserve-its-type-with-typescript-d488c35e5574}
 */
export function deepClone<T>(source: T): T {
    return Array.isArray(source)
        ? source.map((item) => deepClone(item))
        : source instanceof Date
        ? new Date(source.getTime())
        : source && typeof source === 'object'
        ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!);
              o[prop] = deepClone((source as Record<string, unknown>)[prop]);
              return o;
          }, Object.create(Object.getPrototypeOf(source)))
        : source;
}
